export function deserializeMessage(msg) {
    let data = null;
    try {
        data = JSON.parse(msg);
    }
    catch (e) {
        if (e instanceof SyntaxError) {
            return null;
        }
        throw e;
    }
    if (!data || !data.type) {
        console.log("Message data did not contain type attribute", data);
        return null;
    }
    return data;
}
export const createSubscriberAndNotifier = (sender) => (type) => {
    let count = 0;
    const myMap = new Map();
    return {
        type,
        notify: (msg) => sender(JSON.stringify(msg)),
        _notifyOnReceiveMessage: (msg) => {
            if (msg.type === type) {
                myMap.forEach(fn => fn(msg));
            }
        },
        subscribe: (cb) => {
            const instance = count++;
            myMap.set(instance, cb);
            return () => {
                myMap.delete(instance);
            };
        }
    };
};
//# sourceMappingURL=utils.js.map